





































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { StoreFileMixin, ErrorResponseMixin } from '@mixin';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            errorData: null,
            submitted: false,
            post: {
                id: '',
                file: null,
                owner: 'FrontendUser',
                type: 'picture',
            }
        };
    },

    mixins: [
        ErrorResponseMixin,
        StoreFileMixin,
    ],

    created() {
        this.post.id = this.authUser.data.id;
        this.downloadFile(this.post);
    },

    computed: {
        cHeaderClass() {
            const classes = ['user-header', 'user-header--center'];
            
            if (this.file.href)
                classes.push('has-image')

            return classes.join(' ');
        }
    },

    methods: {
        submit() {
            if (this.post.file) {
                this.file.disabled = true;
                this.storeFile(this.post, true).then(response => {
                    this.file.disabled = false;

                    const data = { ...this.file }
                    delete data.disabled;
                    this.$store.dispatch('user/setPicture', data);
                });
            }
        },

        clear() {
            this.file.disabled = true;
            this.removeFile().then(response => {
                this.file.disabled = false;
                this.$store.dispatch('user/setPicture', '');
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ProfileImageForm extends Vue {}

